import {backendUrl} from '@shared/constants/urls/appUrls';
import {fetchWithAuth} from '@shared/utils/auth';

//------------------------------------------------------------------------------
//                                Искать по запросу
//------------------------------------------------------------------------------
export const fetchSearchResults = async (query) => {
  const url = `${backendUrl}/api/search/?q=${query}`;
  const options = {
    method: 'GET',
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при поиске: HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return {
      results: data.results.results,
      next: data.next,
    };
  } catch (error) {
    console.error('Программная ошибка поиска', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//------------------------------------------------------------------------------
//                           Искать по запросу монеты
//------------------------------------------------------------------------------
export const fetchCoinSearchResults = async (query) => {
  const response = await fetch(`https://api2.icodrops.com/portfolio/api/marketTotal/search`, {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({
      query,
      searchItems: [
        {
          type: "markets",
          fields: [
            "currencyId", "rank", "symbol", "name", "slug", "links",
            "image", "price", "marketCap", "change", "ico", "trading", "fdv",
            "contracts"
          ],
        },
      ],
    }),
  });
  const data = await response.json();
  return data.markets;
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//------------------------------------------------------------------------------
//                           Искать по запросу монеты
//------------------------------------------------------------------------------
export const fetchMarketSearchResults = async (currencyIds) => {
  const response = await fetch(`https://api.icodrops.com/portfolio/api/markets`, {
    method: "POST",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({
      page: 0,
      size: 100,
      sort: "rank",
      fields: ["currencyId", "rank", "symbol", "name", "markets", "contracts"],
      currencyIds,
      filters: {trading: true, eligibleForTop: true},
      order: "ASC",
    }),
  });
  const data = await response.json();
  return data.markets.content;
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

//------------------------------------------------------------------------------
//                          Загрузить следующую страницу
//------------------------------------------------------------------------------
export const fetchNextPage = async (url) => {
  const options = {
    method: 'GET',
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка: HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return {
      results: data.results.results,
      next: data.next,
    };
  } catch (error) {
    console.error('Ошибка загрузки следующей страницы:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
